import { render, staticRenderFns } from "./DMYcompare.vue?vue&type=template&id=07b9312c&scoped=true&"
import script from "./DMYcompare.vue?vue&type=script&lang=js&"
export * from "./DMYcompare.vue?vue&type=script&lang=js&"
import style0 from "./DMYcompare.vue?vue&type=style&index=0&id=07b9312c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9312c",
  null
  
)

export default component.exports